import "./index.css";

export function App() {
  return (
    <div className="app">
      <div className="hero-stack">
        <svg
          className="hero-logo"
          width="120"
          height="120"
          viewBox="0 0 120 120"
          role="img"
          aria-label="Team Foundry logo"
        >
          <title>Team Foundry</title>
          <defs>
            <linearGradient id="tfGradient" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#7491FF" />
              <stop offset="55%" stopColor="#FF90E0" />
              <stop offset="100%" stopColor="#F7C325" />
            </linearGradient>
          </defs>
          <circle cx="60" cy="26" r="10" fill="url(#tfGradient)" />
          <circle cx="32" cy="48" r="8" fill="url(#tfGradient)" />
          <circle cx="88" cy="48" r="8" fill="url(#tfGradient)" />
          <circle cx="44" cy="84" r="9" fill="url(#tfGradient)" />
          <circle cx="76" cy="84" r="9" fill="url(#tfGradient)" />
          <path
            d="M60 36 L36 56 L44 76 L76 76 L84 56 Z"
            fill="none"
            stroke="url(#tfGradient)"
            strokeWidth="6"
            strokeLinejoin="round"
          />
        </svg>
        <div className="hero-text">Team Foundry</div>
        <div className="hero-subtext">Coming Soon</div>
        <div className="hero-contact">
          Curious or have a question? Contact us at{" "}
          <a className="hero-contact-link" href="mailto:hello@novaspark.dev">
            hello@novaspark.dev
          </a>
          .
        </div>
      </div>
    </div>
  );
}

export default App;
